import { observable } from "mobx";
import MlsServiceLogType from "../../constants/MlsService/MlsServiceLogType";

class MlsServiceLog {
  /**
   * @property {number|null}
   */
  @observable mlsServiceLogId = null;

  /**
   * @property {number|null}
   */
  @observable mlsServiceId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {string|null}
   */
  @observable entityName = null;

  /**
   * @property {number|null}
   */
  @observable typeId = MlsServiceLogType.CREATE;

  /**
   * @property {number|null}
   */
  @observable creationDts = null;

  constructor({
    mlsServiceLogId = null,
    mlsServiceId = null,
    tourId = null,
    entityName = "",
    typeId = null,
    creationDts = null,
  }) {
    this.mlsServiceLogId = mlsServiceLogId;
    this.mlsServiceId = mlsServiceId;
    this.tourId = tourId;
    this.entityName = entityName;
    this.typeId = typeId;
    this.creationDts = creationDts ? creationDts * 1000 : null;
  }
}

export default MlsServiceLog;
